window.removeItemFromUploader = function (inputDataId, divId, imgId) {
    let tagDiv = $('#' + divId);
    let img = $('#' + imgId);
    let multipleImageInput = $('#' + inputDataId);
    tagDiv.remove();
    var dataUrl = img.attr('data-url');
    var inputValue = multipleImageInput.val();
    inputValue = inputValue.replace(dataUrl, '');
    inputValue = inputValue.replace(',,', ',');
    if (inputValue[0] === ',') {
        inputValue = inputValue.replace(',', '');
    }
    if (inputValue[inputValue.length - 1] === ',') {
        inputValue = inputValue.slice(0, -1);
    }
    multipleImageInput.val(inputValue);
};
window.loadFileUploader = function () {
    try {
        let multipleImageHolder = $('.multipleImageHolder');
        var oldImages = multipleImageHolder.attr('data-olditems');
        var holderId = multipleImageHolder.attr('id');
        var inputDataId = holderId.replace('Holder', 'Data');

        oldImages = oldImages.split(',');
        $.each(oldImages, function (i, item) {
            if (item !== '' && item !== null) {
                let divitem = holderId.replace('Holder', '') + "divitem" + i;
                let spanitem = holderId.replace('Holder', '') + "spanitem" + i;
                let imgitem = holderId.replace('Holder', '') + "igitem" + i;
                var tagDiv = $('<div id="' + divitem + '" style="position: relative;"></div>');
                var tagSpan = $('<span id="' + spanitem + '" style="position: absolute;top: 4px;left: 0;color: white;background-color: #D83237;border-radius:100%;min-width: 20px;min-height: 20px;text-align: center;line-height: 21px;font-size: 14px;cursor: pointer; ">&times;</span>');

                tagDiv.append(tagSpan);
                var img = $('<img id="' + imgitem + '" src="" />');
                tagDiv.append(img);
                img.attr('src', item).trigger('change');
                img.attr('style', 'width:128px;height:113px;margin:10px 5px;border-radius:5px;');
                img.attr('data-url', item);
                multipleImageHolder.append(tagDiv).trigger('change');
                tagSpan.attr('onclick', "removeItemFromUploader('" + inputDataId + "' , '" + divitem + "' , '" + imgitem + "')");
            }
        });

    } catch {
        console.log('uploader is running ... ');
    }
};
loadFileUploader();
window.SingleFileUploader = function (id, uploadUrl = "/admin/upload/image") {

    var loading = $('#loading');
    var input = $('#' + id);
    var type = input.data('type');
    var extensions = input.data('extensions').split(',');
    var inputData = $('#' + id + "Data");
    var file = input[0].files[0];
    let formData = new FormData();
    formData.append("file", file);
    loading.toggleClass('block');
    axios({
        method: "post",
        url: uploadUrl,
        data: formData
    })
        .then(function (response) {
            console.log(response);
            if (extensions.indexOf(response.data.type.split('/')[1]) >= 0) {
                inputData.attr('value', response.data.url);

                if (type === 'image') {
                    var imgHolder = $('#' + id + "Holder");
                    var tagDiv = $('<div style="position: relative;"></div>').insertAfter(imgHolder);
                    var tagSpan = $('<span style="position: absolute;top: 4px;left: 0;color: white;background-color: #D83237;border-radius:100%;min-width: 20px;min-height: 20px;text-align: center;line-height: 21px;font-size: 14px;cursor: pointer; ">&times;</span>');
                    tagDiv.append(tagSpan);
                    imgHolder.attr('src', response.data.url);
                    tagDiv.append(imgHolder);
                    tagSpan.on('click', function (e) {
                        var imgHolder = $('<img class="rounded" src="" id="' + id + 'Holder" style="margin-top:15px;max-width:200px;">').insertAfter(tagDiv);
                        tagDiv.remove();
                        inputData.attr('value', '');
                    })

                } else {
                    var txtHolder = $('#' + id + "Holder");
                    txtHolder.html(response.data.url);
                }
            } else {
                Swal.fire({
                    position: 'center',
                    type: 'error',
                    title: 'File extension not valid',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            loading.toggleClass('block');
        })
        .catch(function (err) {
            let error = err.message;

            //console.log(error);
            // Swal.fire({
            //     position: 'center',
            //     type: 'error',
            //     title: error,
            //     showConfirmButton: false,
            //     timer: 1500
            // });
            loading.removeClass('block');
        });
};

window.UserPhotoUploader = function (id, uploadUrl = "/admin/upload/image", uploadType) {
    var loading = $('#loading');
    var input = $('#' + id);
    var type = input.data('type');
    var extensions = input.data('extensions').split(',');
    var inputData = $('#' + id + "Data");
    var file = input[0].files[0];
    let formData = new FormData();
    formData.append("file", file);
    loading.toggleClass('block');
    axios({
        method: "post",
        url: uploadUrl,
        data: formData
    })
        .then(function (response) {
            if (extensions.indexOf(response.data.type.split('/')[1]) >= 0) {
                inputData.attr('value', response.data.url);

                if (type === 'image') {
                    var imgHolder = $('#' + id + "Holder");
                    var tagDiv = $('<div style="position: relative;"></div>').insertAfter(imgHolder);
                    var tagSpan = $('<span style="position: absolute;top: 4px;left: 0;color: white;background-color: #D83237;border-radius:100%;min-width: 20px;min-height: 20px;text-align: center;line-height: 21px;font-size: 14px;cursor: pointer; ">&times;</span>');
                    tagDiv.append(tagSpan);
                    imgHolder.attr('src', response.data.url);
                    tagDiv.append(imgHolder);

                    if (uploadType===1){
                        document.getElementById("avatar-form").submit();
                    } else if (uploadType===2){
                        document.getElementById("cover-form").submit();
                    }

                }
            } else {
                Vue.$toast.error('File extension not valid');
            }
            loading.toggleClass('block');
        })
        .catch(function (err) {
            if (err.response) {
                if (err.response.status === 500) {
                    Vue.$toast.error('Image size is too large');
                } else if (err.response.status === 422) {
                    Vue.$toast.error('File extension not valid');
                }
            }
            loading.removeClass('block');
        });
};

window.MultipleFileUploader = function (id, uploadUrl = "/file/upload") {
    var loading = $('#loading');
    var input = $('#' + id);
    var allowType = input.data('type').split(',');
    var inputData = $('#' + id + "Data");
    var file = input[0].files[0];
    let formData = new FormData();
    formData.append("file", file);
    loading.toggleClass('block');
    axios({
        method: "post",
        url: uploadUrl,
        data: formData
    })
        .then(function (response) {
            if (allowType.indexOf(response.data.type.split('/')[0]) >= 0) {

                if (inputData.attr('value') !== '' && inputData.attr('value') !== null) {
                    inputData.attr('value', inputData.attr('value') + ',' + response.data.url);
                } else {
                    inputData.attr('value', response.data.url);
                }

                if (response.data.type.split('/')[0] === 'image') {
                    var imgHolder = $('#' + id + "Holder");
                    var tagDiv = $('<div style="position: relative;"></div>');
                    var tagSpan = $('<span style="position: absolute;top: 4px;left: 0;color: white;background-color: #D83237;border-radius:100%;min-width: 20px;min-height: 20px;text-align: center;line-height: 21px;font-size: 14px;cursor: pointer; ">&times;</span>');
                    tagDiv.append(tagSpan);
                    var img = $('<img src="" />');
                    tagDiv.append(img);
                    img.attr('src', response.data.url).trigger('change');
                    img.attr('style', 'width:128px;height:113px;margin:10px 5px;border-radius:5px;');
                    img.attr('data-url', response.data.url);
                    imgHolder.append(tagDiv);

                    tagSpan.on('click', function (e) {
                        tagDiv.remove();
                        var dataUrl = img.attr('data-url');
                        var inputValue = inputData.val();
                        inputValue = inputValue.replace(dataUrl, '');
                        inputValue = inputValue.replace(',,', ',');
                        if (inputValue[0] === ',') {
                            inputValue = inputValue.replace(',', '');
                        }
                        if (inputValue[inputValue.length - 1] === ',') {
                            inputValue = inputValue.slice(0, -1);
                        }

                        inputData.val(inputValue).trigger('change');
                    })
                } else {
                    // var txtHolder = $('#' + id + "Holder");
                    // txtHolder.html(response.data.url);
                }
            } else {
                Swal.fire({
                    position: 'center',
                    type: 'error',
                    title: 'file extension not valid',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
            loading.removeClass('block');
        })
        .catch(function (err) {
            let errors = err;
            console.log("Error");
            console.log(errors);
            Swal.fire({
                position: 'center',
                type: 'error',
                title: 'file is broken',
                showConfirmButton: false,
                timer: 1500
            });
            loading.removeClass('block');
        });
};





